import { render, staticRenderFns } from "./SwitchToggle.vue?vue&type=template&id=3fed75db"
import script from "./SwitchToggle.vue?vue&type=script&lang=js"
export * from "./SwitchToggle.vue?vue&type=script&lang=js"
import style0 from "./SwitchToggle.vue?vue&type=style&index=0&id=3fed75db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports